import { PuzzleIcon } from './PuzzleIcon';

/**
 * author: Google
 * id 0773D18C-C6A2-41B5-9685-F3E0507E1770
 * name puzzle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/puzzle.svg
 * tags
 * - Gaming / RPG 
 */
export const JigsawIcon = PuzzleIcon;
export default JigsawIcon